module.exports = __webpack_public_path__ + "img/diagram_exellent.f1a071fe.svg";